import React from 'react';
import { Container } from '@/components/ui/Container';
import ProfileIdentityCard from '@/components/module/profile/ProfileIdentityCard';
import ProfileAccessCard from '@/components/module/profile/ProfileAccessCard';
import ProfilePasswordCard from '@/components/module/profile/ProfilePasswordCard';
import ProfilePermissionsModal from '@/components/module/profile/ProfilePermissionsModal';
import {
    RolesSectionTitle,
    RolesSectionSubtitle,
    ProfilePageGrid,
    ProfilePageColumn,
} from './style';
import { useProfilePage } from '@hooks/useProfilePage';

const Profile = () => {
    const {
        profile,
        permissionTableRows,
        totalModules,
        totalFeatures,
        totalActions,
        permissionsModalOpen,
        permSearch,
        setPermSearch,
        openPermissionsModal,
        closePermissionsModal,
        isEditing,
        draft,
        updateDraftField,
        startEditing,
        cancelEditing,
        saveProfile,
        profileSaving,
        avatarInputRef,
        avatarUploading,
        openAvatarPicker,
        handleAvatarFileChange,
        passwordVerified,
        currentPassword,
        setCurrentPassword,
        newPassword,
        setNewPassword,
        confirmPassword,
        setConfirmPassword,
        passwordVerifying,
        passwordSaving,
        handleVerifyPassword,
        handleModifyPassword,
        resetPasswordForm,
        copyToClipboard,
    } = useProfilePage();

    if (!profile) {
        return null;
    }

    return (
        <Container
            $display="flex"
            $flexDirection="column"
            $gap="32px"
            $width="100%"
            $maxWidth="1100px"
            $margin="0 auto"
        >
            <Container $marginBottom="8px">
                <RolesSectionTitle>Profile</RolesSectionTitle>
                <RolesSectionSubtitle>
                    Manage your account, security, and workspace access
                </RolesSectionSubtitle>
            </Container>

            <ProfilePageGrid>
                <ProfilePageColumn>
                    <ProfileIdentityCard
                        profile={profile}
                        isEditing={isEditing}
                        draft={draft}
                        onDraftChange={updateDraftField}
                        onStartEdit={startEditing}
                        onCancelEdit={cancelEditing}
                        onSave={saveProfile}
                        profileSaving={profileSaving}
                        avatarInputRef={avatarInputRef}
                        avatarUploading={avatarUploading}
                        onOpenAvatarPicker={openAvatarPicker}
                        onAvatarFileChange={handleAvatarFileChange}
                        onCopyId={copyToClipboard}
                    />
                </ProfilePageColumn>

                <ProfilePageColumn>
                    <ProfileAccessCard
                        role={profile.role}
                        planLabel={profile.planLabel}
                        totalModules={totalModules}
                        totalFeatures={totalFeatures}
                        totalActions={totalActions}
                        onViewPermissions={openPermissionsModal}
                    />
                    <ProfilePasswordCard
                        passwordVerified={passwordVerified}
                        currentPassword={currentPassword}
                        onCurrentPasswordChange={setCurrentPassword}
                        newPassword={newPassword}
                        onNewPasswordChange={setNewPassword}
                        confirmPassword={confirmPassword}
                        onConfirmPasswordChange={setConfirmPassword}
                        passwordVerifying={passwordVerifying}
                        passwordSaving={passwordSaving}
                        onVerifyPassword={handleVerifyPassword}
                        onModifyPassword={handleModifyPassword}
                        onReset={resetPasswordForm}
                    />
                </ProfilePageColumn>
            </ProfilePageGrid>

            <ProfilePermissionsModal
                open={permissionsModalOpen}
                onClose={closePermissionsModal}
                permSearch={permSearch}
                onPermSearchChange={setPermSearch}
                permissionTableRows={permissionTableRows}
            />
        </Container>
    );
};

export default Profile;
